/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */

import { SVGProps } from "react";
import styles from "./Icons.module.scss";

// Note: ideally, the Nebula icons are made available in a repository somewhere,
//       then added to react-icons: https://react-icons.github.io/react-icons/.
//       These manually-created components are a workaround until that is done.

// These components just render HTML without business logic:
/* c8 ignore start */

// Keywords: Arrow
export const ArrowIcon = ({
  alt,
  ...props
}: SVGProps<SVGSVGElement> & { alt: string }) => {
  return (
    <svg
      role="img"
      aria-label={alt}
      aria-hidden={alt === ""}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 14"
      width={16}
      height={14}
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyFill}`}
    >
      <title>{alt}</title>
      <path d="M1.00021 6.00001H12.5862L8.29321 1.70701C7.91424 1.31463 7.91966 0.690926 8.3054 0.305192C8.69113 -0.0805418 9.31483 -0.0859616 9.70721 0.293011L15.7072 6.29301C16.0976 6.68351 16.0976 7.31651 15.7072 7.70701L9.70721 13.707C9.31483 14.086 8.69113 14.0806 8.3054 13.6948C7.91966 13.3091 7.91424 12.6854 8.29321 12.293L12.5862 8.00001H1.00021C0.447928 8.00001 0.000213623 7.5523 0.000213623 7.00001C0.000213623 6.44773 0.447928 6.00001 1.00021 6.00001Z" />
    </svg>
  );
};

// Keywords: cross, X
export const CloseBigIcon = ({
  alt,
  ...props
}: SVGProps<SVGSVGElement> & { alt: string }) => {
  return (
    <svg
      role="img"
      aria-label={alt}
      aria-hidden={alt === ""}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      width={16}
      height={16}
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyFill}`}
    >
      <title>{alt}</title>
      <path d="M9.63004 7.98596L15.6792 1.93681C15.8874 1.72127 16.0026 1.43258 16 1.13293C15.9974 0.833273 15.8772 0.54663 15.6653 0.334735C15.4534 0.12284 15.1667 0.00264711 14.8671 4.3203e-05C14.5674 -0.0025607 14.2787 0.112633 14.0632 0.320813L8.01404 6.36996L1.9649 0.320813C1.74936 0.112633 1.46067 -0.0025607 1.16101 4.3203e-05C0.86136 0.00264711 0.574717 0.12284 0.362822 0.334735C0.150927 0.54663 0.0307344 0.833273 0.0281305 1.13293C0.0255266 1.43258 0.14072 1.72127 0.348901 1.93681L6.39804 7.98596L0.348901 14.0351C0.239746 14.1405 0.152681 14.2666 0.0927849 14.4061C0.0328888 14.5455 0.0013618 14.6955 4.31505e-05 14.8472C-0.0012755 14.999 0.0276408 15.1495 0.0851046 15.2899C0.142569 15.4304 0.227429 15.558 0.334735 15.6653C0.442041 15.7726 0.569643 15.8574 0.710096 15.9149C0.850549 15.9724 1.00104 16.0013 1.15279 16C1.30454 15.9986 1.4545 15.9671 1.59393 15.9072C1.73337 15.8473 1.85948 15.7603 1.9649 15.6511L8.01404 9.60196L14.0632 15.6511C14.2787 15.8593 14.5674 15.9745 14.8671 15.9719C15.1667 15.9693 15.4534 15.8491 15.6653 15.6372C15.8772 15.4253 15.9974 15.1386 16 14.839C16.0026 14.5393 15.8874 14.2506 15.6792 14.0351L9.63004 7.98596Z" />
    </svg>
  );
};

// Keywords: four squares, window, dashboard
export const UnionIcon = ({
  alt,
  ...props
}: SVGProps<SVGSVGElement> & { alt: string }) => {
  return (
    <svg
      role="img"
      aria-label={alt}
      aria-hidden={alt === ""}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 18"
      width={18}
      height={18}
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyFill}`}
    >
      <title>{alt}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 2H6V6H2V2ZM0 2C0 0.895431 0.895431 0 2 0H6C7.10457 0 8 0.895431 8 2V6C8 7.10457 7.10457 8 6 8H2C0.895431 8 0 7.10457 0 6V2ZM12 2H16V6H12V2ZM10 2C10 0.895431 10.8954 0 12 0H16C17.1046 0 18 0.895431 18 2V6C18 7.10457 17.1046 8 16 8H12C10.8954 8 10 7.10457 10 6V2ZM6 12H2V16H6V12ZM2 10C0.895431 10 0 10.8954 0 12V16C0 17.1046 0.895431 18 2 18H6C7.10457 18 8 17.1046 8 16V12C8 10.8954 7.10457 10 6 10H2ZM12 12H16V16H12V12ZM10 12C10 10.8954 10.8954 10 12 10H16C17.1046 10 18 10.8954 18 12V16C18 17.1046 17.1046 18 16 18H12C10.8954 18 10 17.1046 10 16V12Z"
      />
    </svg>
  );
};

// Keywords: menu, hamburger, list
export const ListIcon = ({
  alt,
  ...props
}: SVGProps<SVGSVGElement> & { alt: string }) => {
  return (
    <svg
      role="img"
      aria-label={alt}
      aria-hidden={alt === ""}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12 12"
      width={12}
      height={12}
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyFill}`}
    >
      <title>{alt}</title>
      <path d="M1 2H11C11.2652 2 11.5196 1.89464 11.7071 1.70711C11.8946 1.51957 12 1.26522 12 1C12 0.734784 11.8946 0.48043 11.7071 0.292893C11.5196 0.105357 11.2652 0 11 0H1C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1C0 1.26522 0.105357 1.51957 0.292893 1.70711C0.48043 1.89464 0.734784 2 1 2ZM11 5H1C0.734784 5 0.48043 5.10536 0.292893 5.29289C0.105357 5.48043 0 5.73478 0 6C0 6.26522 0.105357 6.51957 0.292893 6.70711C0.48043 6.89464 0.734784 7 1 7H11C11.2652 7 11.5196 6.89464 11.7071 6.70711C11.8946 6.51957 12 6.26522 12 6C12 5.73478 11.8946 5.48043 11.7071 5.29289C11.5196 5.10536 11.2652 5 11 5ZM11 10H1C0.734784 10 0.48043 10.1054 0.292893 10.2929C0.105357 10.4804 0 10.7348 0 11C0 11.2652 0.105357 11.5196 0.292893 11.7071C0.48043 11.8946 0.734784 12 1 12H11C11.2652 12 11.5196 11.8946 11.7071 11.7071C11.8946 11.5196 12 11.2652 12 11C12 10.7348 11.8946 10.4804 11.7071 10.2929C11.5196 10.1054 11.2652 10 11 10Z" />
    </svg>
  );
};

// Link to icon: https://www.figma.com/file/olFHozlwrdYlCkZaG4B262/Nebula-Design-System-V2-(WIP)?type=design&node-id=665-3694&t=URLSlaDVXUyc57kL-4
export const ChevronDown = ({
  alt,
  ...props
}: SVGProps<SVGSVGElement> & { alt: string }) => {
  return (
    <svg
      role="img"
      aria-label={alt}
      aria-hidden={alt === ""}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 13 7"
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyFill}`}
    >
      <title>{alt}</title>
      <path d="M0.012288 0.999815C0.0123744 0.595419 0.256015 0.230881 0.629633 0.0761372C1.00325 -0.0786067 1.43329 0.0069073 1.71929 0.292815L6.01229 4.58582L10.3053 0.292816C10.6977 -0.0861566 11.3214 -0.0807368 11.7071 0.304997C12.0928 0.690731 12.0983 1.31444 11.7193 1.70682L6.71929 6.70682C6.32879 7.0972 5.69579 7.0972 5.30529 6.70682L0.305288 1.70682C0.117739 1.51932 0.0123447 1.26501 0.012288 0.999815Z"></path>
    </svg>
  );
};

export const OpenInNew = ({
  alt,
  ...props
}: SVGProps<SVGSVGElement> & { alt: string }) => {
  return (
    <svg
      role="img"
      aria-label={alt}
      aria-hidden={alt === ""}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 15 14"
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyFill}`}
    >
      <title>{alt}</title>
      <path d="M4 0H3C1.34315 0 0 1.34315 0 3V11C0 12.6569 1.34315 14 3 14H11C12.6569 14 14 12.6569 14 11V10C14 9.44772 13.5523 9 13 9C12.4477 9 12 9.44772 12 10V11C12 11.5523 11.5523 12 11 12H3C2.44772 12 2 11.5523 2 11V3C2 2.44772 2.44772 2 3 2H4C4.55228 2 5 1.55228 5 1C5 0.447715 4.55228 0 4 0Z" />
      <path d="M13.935 0.618C13.7805 0.244353 13.4163 0.00047005 13.012 0H8.01196C7.45968 0 7.01196 0.447715 7.01196 1C7.01196 1.55228 7.45968 2 8.01196 2H10.598L7.30496 5.293C6.9145 5.68374 6.91472 6.31703 7.30546 6.7075C7.6962 7.09797 8.3295 7.09774 8.71996 6.707L12.013 3.414V6C12.013 6.55228 12.4607 7 13.013 7C13.5652 7 14.013 6.55228 14.013 6V1C14.0126 0.868849 13.9864 0.739052 13.936 0.618H13.935Z" />
    </svg>
  );
};

export const MultipleUsersIcon = ({
  alt,
  ...props
}: SVGProps<SVGSVGElement> & { alt: string }) => {
  return (
    <svg
      role="img"
      aria-label={alt}
      aria-hidden={alt === ""}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyFill}`}
    >
      <title>{alt}</title>
      <path d="M16 9.73366C16 10.1337 15.2 10.4003 14.2667 10.5337C13.6667 9.40033 12.4667 8.53366 11.0667 7.93366C11.2 7.73366 11.3333 7.60033 11.4667 7.40033H12C14.0667 7.33366 16 8.60033 16 9.73366V9.73366ZM4.53333 7.33366H4C1.93333 7.33366 0 8.60033 0 9.73366C0 10.1337 0.8 10.4003 1.73333 10.5337C2.33333 9.40033 3.53333 8.53366 4.93333 7.93366L4.53333 7.33366V7.33366ZM8 8.00033C9.46667 8.00033 10.6667 6.80033 10.6667 5.33366C10.6667 3.86699 9.46667 2.66699 8 2.66699C6.53333 2.66699 5.33333 3.86699 5.33333 5.33366C5.33333 6.80033 6.53333 8.00033 8 8.00033ZM8 8.66699C5.26667 8.66699 2.66667 10.4003 2.66667 12.0003C2.66667 13.3337 8 13.3337 8 13.3337C8 13.3337 13.3333 13.3337 13.3333 12.0003C13.3333 10.4003 10.7333 8.66699 8 8.66699ZM11.8 6.66699H12C13.1333 6.66699 14 5.80033 14 4.66699C14 3.53366 13.1333 2.66699 12 2.66699C11.6667 2.66699 11.4 2.73366 11.1333 2.86699C11.6667 3.53366 12 4.40033 12 5.33366C12 5.80033 11.9333 6.26699 11.8 6.66699ZM4 6.66699H4.2C4.06667 6.26699 4 5.80033 4 5.33366C4 4.40033 4.33333 3.53366 4.86667 2.86699C4.6 2.73366 4.33333 2.66699 4 2.66699C2.86667 2.66699 2 3.53366 2 4.66699C2 5.80033 2.86667 6.66699 4 6.66699Z" />
    </svg>
  );
};

export const PhoneIcon = ({
  alt,
  ...props
}: SVGProps<SVGSVGElement> & { alt: string }) => {
  return (
    <svg
      role="img"
      aria-label={alt}
      aria-hidden={alt === ""}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14 14"
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyFill}`}
    >
      <title>{alt}</title>
      <path d="M8.67166 9.24002L9.79166 8.12002C9.94251 7.97104 10.1334 7.86906 10.3411 7.82646C10.5487 7.78385 10.7643 7.80246 10.9617 7.88002L12.3267 8.42502C12.5261 8.50596 12.697 8.64411 12.8181 8.82207C12.9391 9.00003 13.0047 9.20983 13.0067 9.42502V11.925C13.0055 12.0714 12.9747 12.216 12.9162 12.3502C12.8577 12.4844 12.7726 12.6054 12.6661 12.7058C12.5596 12.8062 12.4338 12.8841 12.2964 12.9346C12.1591 12.9852 12.0129 13.0074 11.8667 13C2.30166 12.405 0.371659 4.30502 0.00665873 1.20502C-0.0102848 1.05279 0.00519605 0.898694 0.0520828 0.752875C0.0989696 0.607056 0.1762 0.472817 0.278692 0.358988C0.381185 0.24516 0.506617 0.154323 0.646738 0.0924523C0.786858 0.0305818 0.93849 -0.00091958 1.09166 2.04345e-05H3.50666C3.72216 0.000658328 3.93255 0.0657541 4.11076 0.186935C4.28896 0.308116 4.42684 0.47984 4.50666 0.680021L5.05166 2.04502C5.13179 2.24155 5.15223 2.45734 5.11043 2.66543C5.06864 2.87351 4.96646 3.06467 4.81666 3.21502L3.69666 4.33502C3.69666 4.33502 4.34166 8.70002 8.67166 9.24002Z" />
    </svg>
  );
};

export const EmailIcon = ({
  alt,
  ...props
}: SVGProps<SVGSVGElement> & { alt: string }) => {
  return (
    <svg
      role="img"
      aria-label={alt}
      aria-hidden={alt === ""}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 15 15"
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyFill}`}
    >
      <title>{alt}</title>
      <path d="M14.37 2.66679C14.3095 2.66055 14.2484 2.66055 14.1878 2.66679H1.74337C1.66361 2.66802 1.58438 2.67998 1.50781 2.70235L7.93003 9.0979L14.37 2.66679Z" />
      <path d="M15.0283 3.28516L8.55715 9.7296C8.39061 9.89516 8.16532 9.98808 7.93049 9.98808C7.69565 9.98808 7.47036 9.89516 7.30382 9.7296L0.890486 3.33405C0.87077 3.40651 0.860317 3.48118 0.859375 3.55627V12.4452C0.859375 12.6809 0.953026 12.907 1.11972 13.0737C1.28642 13.2404 1.51252 13.334 1.74826 13.334H14.1927C14.4285 13.334 14.6545 13.2404 14.8212 13.0737C14.9879 12.907 15.0816 12.6809 15.0816 12.4452V3.55627C15.0781 3.46367 15.0601 3.37219 15.0283 3.28516V3.28516ZM2.35715 12.4452H1.73938V11.8096L4.97049 8.60516L5.59715 9.23182L2.35715 12.4452ZM14.1838 12.4452H13.5616L10.3216 9.23182L10.9483 8.60516L14.1794 11.8096L14.1838 12.4452Z" />
    </svg>
  );
};

// Keywords: email, envelope, outline
// Link to icon: https://www.figma.com/design/eLH4KiHC3FxEPwr6uNMnE9/Pixel-Perfect-Icon-Set-%E2%80%93%C2%A0Source?node-id=106-10937&m=dev
export const EmailOutlineIcon = ({
  alt,
  ...props
}: SVGProps<SVGSVGElement> & { alt: string }) => {
  return (
    <svg
      role="img"
      aria-label={alt}
      aria-hidden={alt === ""}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyStroke}`}
      fill="transparent"
    >
      <title>{alt}</title>
      <path
        d="M16 5H18C19.7 5 21 6.3 21 8V16C21 17.7 19.7 19 18 19H6C4.3 19 3 17.7 3 16V8C3 6.3 4.3 5 6 5H8H16Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.8996 7.19995L14.2996 13L11.9996 15L9.69961 13L3.09961 7.19995"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.70039 13L3.90039 18.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.0998 18.2L14.2998 13"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

// Keywords: mailbox, inbox
// Link to icon: https://www.figma.com/design/eLH4KiHC3FxEPwr6uNMnE9/Pixel-Perfect-Icon-Set-%E2%80%93%C2%A0Source?node-id=106-11247&t=rzqMRa2ZGRqbRo11-4
export const MailboxOutlineIcon = ({
  alt,
  ...props
}: SVGProps<SVGSVGElement> & { alt: string }) => {
  return (
    <svg
      role="img"
      aria-label={alt}
      aria-hidden={alt === ""}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyStroke}`}
      fill="transparent"
    >
      <title>{alt}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 10V17H3V10C3 7.8 4.8 6 7 6C9.2 6 11 7.8 11 10Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 10V17H3V10C3 7.8 4.8 6 7 6H17C19.2 6 21 7.8 21 10Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 17L16 21"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 3H18C16.8954 3 16 3.89543 16 5V11"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

// Keywords: contact, person, info
// Link to icon: https://www.figma.com/design/eLH4KiHC3FxEPwr6uNMnE9/Pixel-Perfect-Icon-Set-%E2%80%93%C2%A0Source?node-id=106-16231&t=yP5KZQSgof8HbkkD-4
export const ContactsOutlineIcon = ({
  alt,
  ...props
}: SVGProps<SVGSVGElement> & { alt: string }) => {
  return (
    <svg
      role="img"
      aria-label={alt}
      aria-hidden={alt === ""}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyStroke}`}
      fill="transparent"
    >
      <title>{alt}</title>
      <path
        d="M3 17V7C3 4.8 4.8 3 7 3H17C19.2 3 21 4.8 21 7V17C21 19.2 19.2 21 17 21H7C4.8 21 3 19.2 3 17Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 11.7C13.3 11.7 14.3 10.7 14.3 9.4C14.3 8.1 13.3 7 12 7C10.7 7 9.69995 8 9.69995 9.3C9.69995 10.6 10.7 11.7 12 11.7Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.6001 21V20.2C6.6001 18.7 7.2001 17.3 8.2001 16.3C9.2001 15.3 10.5001 14.7 12.1001 14.7C15.1001 14.7 17.5001 17.1 17.5001 20.1V21"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LocationPinIcon = ({
  alt,
  ...props
}: SVGProps<SVGSVGElement> & { alt: string }) => {
  return (
    <svg
      role="img"
      aria-label={alt}
      aria-hidden={alt === ""}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 11 14"
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyFill}`}
    >
      <title>{alt}</title>
      <path d="M5.50001 0C4.04184 0.00172024 2.6439 0.581735 1.61282 1.61281C0.581741 2.64389 0.00172609 4.04184 5.85144e-06 5.5C-0.00174059 6.69161 0.387496 7.85089 1.10801 8.8C1.10801 8.8 1.25801 8.9975 1.28251 9.026L5.50001 14L9.71951 9.0235C9.74151 8.997 9.89201 8.8 9.89201 8.8L9.89251 8.7985C10.6127 7.84981 11.0017 6.69107 11 5.5C10.9983 4.04184 10.4183 2.64389 9.38719 1.61281C8.35612 0.581735 6.95817 0.00172024 5.50001 0V0ZM5.50001 7.5C5.10444 7.5 4.71776 7.3827 4.38887 7.16294C4.05997 6.94318 3.80362 6.63082 3.65225 6.26537C3.50087 5.89991 3.46126 5.49778 3.53844 5.10982C3.61561 4.72186 3.80609 4.36549 4.08579 4.08579C4.3655 3.80608 4.72186 3.6156 5.10983 3.53843C5.49779 3.46126 5.89992 3.50087 6.26537 3.65224C6.63082 3.80362 6.94318 4.05996 7.16294 4.38886C7.38271 4.71776 7.50001 5.10444 7.50001 5.5C7.49934 6.03023 7.28842 6.53855 6.91349 6.91348C6.53856 7.28841 6.03024 7.49934 5.50001 7.5V7.5Z" />
    </svg>
  );
};

// Keywords: Info, tooltip, tip
export const QuestionMarkCircle = ({
  alt,
  ...props
}: SVGProps<SVGSVGElement> & { alt: string }) => {
  return (
    <svg
      role="img"
      aria-label={alt}
      aria-hidden={alt === ""}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 13 13"
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyFill}`}
    >
      <title>{alt}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6667 6C10.6667 8.57733 8.57733 10.6667 6 10.6667C3.42267 10.6667 1.33333 8.57733 1.33333 6C1.33333 3.42267 3.42267 1.33333 6 1.33333C8.57733 1.33333 10.6667 3.42267 10.6667 6ZM12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6ZM5.16735 2.78151C5.4077 2.69128 5.66457 2.6535 5.92072 2.67072C6.34018 2.6563 6.75252 2.78177 7.09286 3.02737C7.4332 3.27297 7.68221 3.62476 7.80072 4.02739C7.89751 4.41073 7.86226 4.81551 7.70065 5.17635C7.53904 5.53719 7.26051 5.83302 6.91005 6.01605C6.80075 6.06483 6.70593 6.14105 6.63479 6.23731C6.56365 6.33357 6.51861 6.44658 6.50405 6.56539V6.81205C6.50405 6.96676 6.44259 7.11514 6.3332 7.22453C6.2238 7.33393 6.07543 7.39539 5.92072 7.39539C5.76601 7.39539 5.61764 7.33393 5.50824 7.22453C5.39884 7.11514 5.33739 6.96676 5.33739 6.81205V6.58739C5.34511 6.26061 5.44044 5.94191 5.61341 5.66456C5.78639 5.38722 6.03066 5.16141 6.32072 5.01072C6.44962 4.95708 6.55561 4.85989 6.62018 4.73611C6.68475 4.61232 6.70382 4.46979 6.67405 4.33339C6.6212 4.17892 6.51853 4.04639 6.38217 3.95662C6.24581 3.86684 6.0835 3.8249 5.92072 3.83739C5.57072 3.83739 5.17072 3.92072 5.17072 4.58739C5.17072 4.7421 5.10926 4.89047 4.99987 4.99987C4.89047 5.10926 4.7421 5.17072 4.58739 5.17072C4.43268 5.17072 4.2843 5.10926 4.17491 4.99987C4.06551 4.89047 4.00405 4.7421 4.00405 4.58739C3.98684 4.33124 4.02461 4.07437 4.11484 3.83402C4.20507 3.59367 4.34567 3.37541 4.52721 3.19387C4.70874 3.01234 4.92701 2.87174 5.16735 2.78151ZM5.45774 7.8945C5.59479 7.80293 5.7559 7.75405 5.92072 7.75405C6.14173 7.75405 6.35369 7.84185 6.50998 7.99813C6.66626 8.15441 6.75405 8.36637 6.75405 8.58739C6.75405 8.7522 6.70518 8.91332 6.61361 9.05036C6.52204 9.1874 6.39189 9.29421 6.23962 9.35729C6.08735 9.42036 5.9198 9.43686 5.75814 9.40471C5.59649 9.37255 5.44801 9.29319 5.33146 9.17664C5.21492 9.0601 5.13555 8.91161 5.1034 8.74996C5.07124 8.58831 5.08775 8.42075 5.15082 8.26848C5.21389 8.11621 5.3207 7.98606 5.45774 7.8945Z"
      />
    </svg>
  );
};

// Keywords: error, warning, exclamation mark
// https://www.figma.com/file/olFHozlwrdYlCkZaG4B262/Nebula-Design-System-V2-(WIP)?type=design&node-id=109-1376
export const ErrorIcon = ({
  alt,
  ...props
}: SVGProps<SVGSVGElement> & { alt: string }) => {
  return (
    <svg
      role="img"
      aria-label={alt}
      aria-hidden={alt === ""}
      xmlns="http://www.w3.org/2000/svg"
      width={14}
      height={14}
      viewBox="0 0 14 14"
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyFill}`}
    >
      <path d="M13.6929 11.0119L8.73994 1.10586C8.57386 0.773576 8.31852 0.494108 8.00254 0.298784C7.68656 0.10346 7.32242 0 6.95094 0C6.57946 0 6.21532 0.10346 5.89934 0.298784C5.58336 0.494108 5.32802 0.773576 5.16194 1.10586L0.20894 11.0159C0.0574972 11.3206 -0.0136719 11.659 0.00216778 11.999C0.0180075 12.3389 0.120332 12.6692 0.299458 12.9586C0.478583 13.2479 0.728584 13.4868 1.0258 13.6526C1.32302 13.8183 1.65762 13.9055 1.99794 13.9059H11.9029C12.2439 13.906 12.5792 13.819 12.8771 13.6531C13.1749 13.4872 13.4255 13.2479 13.6048 12.9579C13.7842 12.668 13.8864 12.337 13.9018 11.9964C13.9172 11.6557 13.8453 11.3169 13.6929 11.0119ZM5.95094 3.90586C5.95094 3.64065 6.0563 3.38629 6.24383 3.19876C6.43137 3.01122 6.68572 2.90586 6.95094 2.90586C7.21616 2.90586 7.47051 3.01122 7.65805 3.19876C7.84558 3.38629 7.95094 3.64065 7.95094 3.90586V7.90586C7.95094 8.17108 7.84558 8.42543 7.65805 8.61297C7.47051 8.80051 7.21616 8.90586 6.95094 8.90586C6.68572 8.90586 6.43137 8.80051 6.24383 8.61297C6.0563 8.42543 5.95094 8.17108 5.95094 7.90586V3.90586ZM6.95094 12.1559C6.70371 12.1559 6.46204 12.0826 6.25648 11.9452C6.05092 11.8078 5.8907 11.6126 5.79609 11.3842C5.70148 11.1558 5.67673 10.9045 5.72496 10.662C5.77319 10.4195 5.89224 10.1968 6.06706 10.022C6.24187 9.84717 6.4646 9.72811 6.70708 9.67988C6.94955 9.63165 7.20089 9.65641 7.42929 9.75101C7.6577 9.84562 7.85292 10.0058 7.99028 10.2114C8.12763 10.417 8.20094 10.6586 8.20094 10.9059C8.20094 11.2374 8.06924 11.5553 7.83482 11.7897C7.6004 12.0242 7.28246 12.1559 6.95094 12.1559Z" />
    </svg>
  );
};

// Keywords: delete, remove, trash can, rubbish bin
// https://www.figma.com/file/olFHozlwrdYlCkZaG4B262/Nebula-Design-System-V2-(WIP)?type=design&node-id=109-1398
export const DeleteIcon = ({
  alt,
  ...props
}: SVGProps<SVGSVGElement> & { alt: string }) => {
  return (
    <svg
      role="img"
      aria-label={alt}
      aria-hidden={alt === ""}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyFill}`}
    >
      <path
        fillRule="evenodd"
        d="M14.95 6H18a1 1 0 110 2v9a3 3 0 01-3 3h-5a3 3 0 01-3-3V8a1 1 0 110-2h3.05a2.5 2.5 0 014.9 0zm-1.059 0A1.489 1.489 0 0012.5 5a1.489 1.489 0 00-1.391 1h2.782zM16 17a1 1 0 01-1 1h-5a1 1 0 01-1-1V8h7v9zm-5-1.5a.5.5 0 01-1 0v-6a.5.5 0 011 0v6zm2 0a.5.5 0 01-1 0v-6a.5.5 0 011 0v6zm1.5.5a.5.5 0 00.5-.5v-6a.5.5 0 00-1 0v6a.5.5 0 00.5.5z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

// Keywords: close, exit, cross
// https://www.figma.com/file/olFHozlwrdYlCkZaG4B262/Nebula-Design-System-V2-(WIP)?type=design&node-id=109-1385&t=kxEcvIQoafGdPZ3y-4
export const CloseBtn = ({
  alt,
  ...props
}: SVGProps<SVGSVGElement> & { alt: string }) => {
  return (
    <svg
      role="img"
      aria-label={alt}
      aria-hidden={alt === ""}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyFill}`}
    >
      <title>{alt}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.63004 7.98596L15.6792 1.93681C15.8874 1.72127 16.0026 1.43258 16 1.13293C15.9974 0.833273 15.8772 0.54663 15.6653 0.334735C15.4534 0.12284 15.1667 0.00264711 14.8671 4.3203e-05C14.5674 -0.0025607 14.2787 0.112633 14.0632 0.320813L8.01404 6.36996L1.9649 0.320813C1.74936 0.112633 1.46067 -0.0025607 1.16101 4.3203e-05C0.86136 0.00264711 0.574717 0.12284 0.362822 0.334735C0.150927 0.54663 0.0307344 0.833273 0.0281305 1.13293C0.0255266 1.43258 0.14072 1.72127 0.348901 1.93681L6.39804 7.98596L0.348901 14.0351C0.239746 14.1405 0.152681 14.2666 0.0927849 14.4061C0.0328888 14.5455 0.0013618 14.6955 4.31505e-05 14.8472C-0.0012755 14.999 0.0276408 15.1495 0.0851046 15.2899C0.142569 15.4304 0.227429 15.558 0.334735 15.6653C0.442041 15.7726 0.569643 15.8574 0.710096 15.9149C0.850549 15.9724 1.00104 16.0013 1.15279 16C1.30454 15.9986 1.4545 15.9671 1.59393 15.9072C1.73337 15.8473 1.85948 15.7603 1.9649 15.6511L8.01404 9.60196L14.0632 15.6511C14.2787 15.8593 14.5674 15.9745 14.8671 15.9719C15.1667 15.9693 15.4534 15.8491 15.6653 15.6372C15.8772 15.4253 15.9974 15.1386 16 14.839C16.0026 14.5393 15.8874 14.2506 15.6792 14.0351L9.63004 7.98596Z"
      />
    </svg>
  );
};

// Link to icon: https://www.figma.com/file/olFHozlwrdYlCkZaG4B262/Nebula-Design-System-V2-(WIP)?type=design&node-id=3515-9584&mode=design&t=O0YJKrRAhztcOpXU-4
// Keywords: View Grid, ViewGrid, Bento, AppPicker, App Picker
export const BentoIcon = (props: SVGProps<SVGSVGElement> & { alt: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      role="img"
      aria-label={props.alt}
      aria-hidden={props.alt === ""}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyFill}`}
    >
      <title>{props.alt}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 2.5C1.5 1.94772 1.94772 1.5 2.5 1.5H6.5C7.05228 1.5 7.5 1.94772 7.5 2.5V6.5C7.5 7.05228 7.05228 7.5 6.5 7.5H2.5C1.94772 7.5 1.5 7.05228 1.5 6.5V2.5ZM9 2.5C9 1.94772 9.44772 1.5 10 1.5H14C14.5523 1.5 15 1.94772 15 2.5V6.5C15 7.05228 14.5523 7.5 14 7.5H10C9.44772 7.5 9 7.05228 9 6.5V2.5ZM17.5 1.5C16.9477 1.5 16.5 1.94772 16.5 2.5V6.5C16.5 7.05228 16.9477 7.5 17.5 7.5H21.5C22.0523 7.5 22.5 7.05228 22.5 6.5V2.5C22.5 1.94772 22.0523 1.5 21.5 1.5H17.5ZM1.5 10C1.5 9.44772 1.94772 9 2.5 9H6.5C7.05228 9 7.5 9.44772 7.5 10V14C7.5 14.5523 7.05228 15 6.5 15H2.5C1.94772 15 1.5 14.5523 1.5 14V10ZM10 9C9.44772 9 9 9.44772 9 10V14C9 14.5523 9.44772 15 10 15H14C14.5523 15 15 14.5523 15 14V10C15 9.44772 14.5523 9 14 9H10ZM16.5 10C16.5 9.44772 16.9477 9 17.5 9H21.5C22.0523 9 22.5 9.44772 22.5 10V14C22.5 14.5523 22.0523 15 21.5 15H17.5C16.9477 15 16.5 14.5523 16.5 14V10ZM2.5 16.5C1.94772 16.5 1.5 16.9477 1.5 17.5V21.5C1.5 22.0523 1.94772 22.5 2.5 22.5H6.5C7.05228 22.5 7.5 22.0523 7.5 21.5V17.5C7.5 16.9477 7.05228 16.5 6.5 16.5H2.5ZM9 17.5C9 16.9477 9.44772 16.5 10 16.5H14C14.5523 16.5 15 16.9477 15 17.5V21.5C15 22.0523 14.5523 22.5 14 22.5H10C9.44772 22.5 9 22.0523 9 21.5V17.5ZM17.5 16.5C16.9477 16.5 16.5 16.9477 16.5 17.5V21.5C16.5 22.0523 16.9477 22.5 17.5 22.5H21.5C22.0523 22.5 22.5 22.0523 22.5 21.5V17.5C22.5 16.9477 22.0523 16.5 21.5 16.5H17.5Z"
      />
    </svg>
  );
};

// Link to icon: https://www.figma.com/file/olFHozlwrdYlCkZaG4B262/Nebula-Design-System-V2-(WIP)?type=design&node-id=109-1405&mode=design&t=WbRVICi1MjCbri9t-4
export const FilterIcon = (
  props: SVGProps<SVGSVGElement> & { alt: string },
) => {
  return (
    <svg
      width="18"
      height="12"
      viewBox="0 0 20 12"
      role="img"
      aria-label={props.alt}
      aria-hidden={props.alt === ""}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyFill}`}
    >
      <title>{props.alt}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 12H10C10.55 12 11 11.55 11 11C11 10.45 10.55 10 10 10H8C7.45 10 7 10.45 7 11C7 11.55 7.45 12 8 12ZM0 1C0 1.55 0.45 2 1 2H17C17.55 2 18 1.55 18 1C18 0.45 17.55 0 17 0H1C0.45 0 0 0.45 0 1ZM4 7H14C14.55 7 15 6.55 15 6C15 5.45 14.55 5 14 5H4C3.45 5 3 5.45 3 6C3 6.55 3.45 7 4 7Z"
      />
    </svg>
  );
};

// Keywords: lock, slashed lock
export const PasswordIcon = (
  props: SVGProps<SVGSVGElement> & { alt: string },
) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 14 14"
      role="img"
      aria-label={props.alt}
      aria-hidden={props.alt === ""}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyFill}`}
    >
      <title>{props.alt}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3336 6.55996H10.9643L4.85722 12.667H11.3336C11.6367 12.667 11.9274 12.5466 12.1417 12.3323C12.3561 12.118 12.4765 11.8273 12.4765 11.5241V7.70284C12.4765 7.39973 12.3561 7.10904 12.1417 6.8947C11.9274 6.68037 11.6367 6.55996 11.3336 6.55996ZM6.38107 6.55996V5.04779C6.38107 4.64364 6.54162 4.25605 6.82739 3.97027C7.11317 3.68449 7.50077 3.52395 7.90492 3.52395C8.30907 3.52395 8.69666 3.68449 8.98244 3.97027C9.26822 4.25605 9.42877 4.64364 9.42877 5.04779V5.80972L10.8703 4.36816C10.7039 3.63814 10.2742 2.99505 9.66355 2.56181C9.05286 2.12856 8.30394 1.93554 7.55992 2.01964C6.8159 2.10373 6.12896 2.45904 5.63037 3.01766C5.13179 3.57628 4.85654 4.29903 4.85722 5.04779V6.55996H4.47626C4.17315 6.55996 3.88245 6.68037 3.66812 6.8947C3.45378 7.10904 3.33337 7.39973 3.33337 7.70284V11.5241C3.33492 11.6354 3.3529 11.7458 3.38671 11.8518L8.67852 6.55996H6.38107Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.77372 13.3333C2.62071 13.3334 2.47112 13.2881 2.34388 13.2031C2.21663 13.1181 2.11745 12.9973 2.05889 12.856C2.00033 12.7146 1.98501 12.5591 2.01488 12.409C2.04475 12.2589 2.11846 12.1211 2.22669 12.013L12.0227 2.21709C12.1686 2.07622 12.3639 1.99827 12.5667 2.00003C12.7695 2.00179 12.9634 2.08312 13.1068 2.22651C13.2502 2.3699 13.3315 2.56387 13.3333 2.76664C13.3351 2.96941 13.2571 3.16476 13.1162 3.31062L3.32023 13.1065C3.17534 13.2516 2.97876 13.3332 2.77372 13.3333V13.3333Z"
      />
    </svg>
  );
};

// Keywords: lock, padlock
export const LockIcon = (props: SVGProps<SVGSVGElement> & { alt: string }) => {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      role="img"
      aria-label={props.alt}
      aria-hidden={props.alt === ""}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyFill}`}
    >
      <title>{props.alt}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8242 6.83962H12.2513V4.57143C12.2513 3.35901 11.7684 2.19625 10.9089 1.33894C10.0493 0.481631 8.88354 0 7.66797 0C6.45239 0 5.2866 0.481631 4.42706 1.33894C3.56752 2.19625 3.08464 3.35901 3.08464 4.57143V6.83962H2.51172C2.05588 6.83962 1.61871 7.02023 1.29638 7.34172C0.974051 7.66321 0.792969 8.09925 0.792969 8.55391V14.2857C0.792969 14.7404 0.974051 15.1764 1.29638 15.4979C1.61871 15.8194 2.05588 16 2.51172 16H12.8242C13.2801 16 13.7172 15.8194 14.0396 15.4979C14.3619 15.1764 14.543 14.7404 14.543 14.2857V8.55391C14.543 8.09925 14.3619 7.66321 14.0396 7.34172C13.7172 7.02023 13.2801 6.83962 12.8242 6.83962ZM5.3763 4.57143C5.3763 3.96522 5.61774 3.38384 6.04751 2.95518C6.47729 2.52653 7.06018 2.28571 7.66797 2.28571C8.27576 2.28571 8.85865 2.52653 9.28842 2.95518C9.71819 3.38384 9.95963 3.96522 9.95963 4.57143V6.83962H5.3763V4.57143Z"
      />
    </svg>
  );
};

// Keywords: time, estimated, watch
export const ClockIcon = (props: SVGProps<SVGSVGElement> & { alt: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      role="img"
      aria-label={props.alt}
      aria-hidden={props.alt === ""}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyFill}`}
    >
      <title>{props.alt}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 0C9.62663 0 7.30655 0.703788 5.33316 2.02236C3.35977 3.34094 1.8217 5.21508 0.913451 7.4078C0.00519937 9.60051 -0.232441 12.0133 0.230582 14.3411C0.693605 16.6689 1.83649 18.807 3.51472 20.4853C5.19295 22.1635 7.33115 23.3064 9.65892 23.7694C11.9867 24.2324 14.3995 23.9948 16.5922 23.0865C18.7849 22.1783 20.6591 20.6402 21.9776 18.6668C23.2962 16.6934 24 14.3734 24 12C23.9964 8.8185 22.731 5.76833 20.4813 3.51866C18.2317 1.269 15.1815 0.00357316 12 0ZM12 21C10.22 21 8.47992 20.4722 6.99987 19.4832C5.51983 18.4943 4.36628 17.0887 3.68509 15.4441C3.0039 13.7996 2.82567 11.99 3.17294 10.2442C3.5202 8.49836 4.37737 6.89471 5.63604 5.63604C6.89472 4.37736 8.49836 3.5202 10.2442 3.17293C11.99 2.82566 13.7996 3.00389 15.4442 3.68508C17.0887 4.36627 18.4943 5.51982 19.4832 6.99987C20.4722 8.47991 21 10.22 21 12C20.9972 14.3861 20.0481 16.6737 18.3609 18.3609C16.6737 20.0481 14.3861 20.9972 12 21ZM17.25 12H12V6.75C12 6.55109 11.921 6.36032 11.7803 6.21967C11.6397 6.07902 11.4489 6 11.25 6C11.0511 6 10.8603 6.07902 10.7197 6.21967C10.579 6.36032 10.5 6.55109 10.5 6.75V12.75C10.5 12.9489 10.579 13.1397 10.7197 13.2803C10.8603 13.421 11.0511 13.5 11.25 13.5H17.25C17.4489 13.5 17.6397 13.421 17.7803 13.2803C17.921 13.1397 18 12.9489 18 12.75C18 12.5511 17.921 12.3603 17.7803 12.2197C17.6397 12.079 17.4489 12 17.25 12Z"
      />
    </svg>
  );
};

// Keywords: time, estimated, watch, big
export const ClockIconBig = (
  props: SVGProps<SVGSVGElement> & { alt: string },
) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      role="img"
      aria-label={props.alt}
      aria-hidden={props.alt === ""}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyFill}`}
    >
      <title>{props.alt}</title>
      <path d="M20.5587 0.216003C16.6244 0.216003 12.7785 1.38265 9.50726 3.56841C6.23604 5.75417 3.68643 8.86088 2.18085 12.4957C0.675275 16.1305 0.281347 20.1301 1.04888 23.9887C1.81642 27.8474 3.71095 31.3918 6.4929 34.1738C9.27484 36.9557 12.8193 38.8502 16.6779 39.6178C20.5366 40.3853 24.5362 39.9914 28.171 38.4858C31.8058 36.9802 34.9125 34.4306 37.0983 31.1594C39.284 27.8882 40.4507 24.0423 40.4507 20.108C40.4507 17.4957 39.9361 14.9091 38.9365 12.4957C37.9368 10.0823 36.4716 7.88938 34.6244 6.04223C32.7773 4.19509 30.5844 2.72986 28.171 1.73019C25.7576 0.730525 23.1709 0.216003 20.5587 0.216003ZM20.5587 38.4C16.9408 38.4 13.4043 37.3272 10.3962 35.3172C7.38807 33.3073 5.04354 30.4505 3.65906 27.108C2.27458 23.7656 1.91234 20.0877 2.61814 16.5394C3.32394 12.9911 5.06609 9.73179 7.62427 7.17361C10.1825 4.61542 13.4418 2.87328 16.9901 2.16748C20.5384 1.46168 24.2163 1.82392 27.5587 3.2084C30.9011 4.59288 33.758 6.93741 35.7679 9.94551C37.7779 12.9536 38.8507 16.4902 38.8507 20.108C38.8454 24.9577 36.9165 29.6073 33.4872 33.0366C30.0579 36.4658 25.4084 38.3947 20.5587 38.4Z" />
      <path d="M28.8746 23.3721L21.3586 19.6001V8.17206C21.3586 7.95988 21.2744 7.7564 21.1243 7.60637C20.9743 7.45634 20.7708 7.37206 20.5586 7.37206C20.3465 7.37206 20.143 7.45634 19.993 7.60637C19.8429 7.7564 19.7586 7.95988 19.7586 8.17206V20.1081C19.7587 20.2569 19.8003 20.4028 19.8788 20.5292C19.9572 20.6557 20.0694 20.7578 20.2026 20.8241L28.1587 24.8001C28.2688 24.8565 28.3909 24.8853 28.5147 24.8841C28.6938 24.883 28.8674 24.8218 29.0076 24.7104C29.1479 24.5989 29.2467 24.4436 29.2882 24.2694C29.3296 24.0951 29.3114 23.9119 29.2365 23.7492C29.1615 23.5866 29.0341 23.4537 28.8746 23.3721Z" />
    </svg>
  );
};

// Keywords: shield, secure, protected
export const ShieldIconBig = (
  props: SVGProps<SVGSVGElement> & { alt: string },
) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      role="img"
      aria-label={props.alt}
      aria-hidden={props.alt === ""}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyFill}`}
    >
      <title>{props.alt}</title>
      <path d="M20.216 0.3361C20.1424 0.260985 20.0547 0.201124 19.9579 0.159942C19.8611 0.11876 19.7572 0.0970658 19.652 0.0960999C19.5462 0.0965393 19.4415 0.117979 19.344 0.159176C19.2465 0.200373 19.1581 0.260509 19.084 0.3361L4.20001 6.6881V20.2001C4.20001 27.9241 15.8 39.9081 19.644 39.9081C23.488 39.9081 35.088 27.9081 35.088 20.2001V6.6881L20.216 0.3361ZM18.844 38.08C17.356 37.42 14.596 35.316 11.692 31.912C8.00001 27.6 5.80001 23.2 5.80001 20.2V7.74398L18.844 2.17598V38.08ZM33.488 20.2C33.488 23.2 31.288 27.6 27.6 31.912C24.692 35.316 21.932 37.42 20.444 38.08V2.17598L33.488 7.74398V20.2Z" />
    </svg>
  );
};

// Keywords: heart, love, like
export const HeartIconBig = (
  props: SVGProps<SVGSVGElement> & { alt: string },
) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      role="img"
      aria-label={props.alt}
      aria-hidden={props.alt === ""}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyFill}`}
    >
      <title>{props.alt}</title>
      <path d="M29.8054 4.22402C31.5709 4.22444 33.2966 4.74828 34.7644 5.72933C36.2322 6.71038 37.3762 8.10459 38.0518 9.73571C38.7274 11.3668 38.9042 13.1616 38.5599 14.8932C38.2155 16.6248 37.3656 18.2154 36.1174 19.464L34.0894 21.496L20.3334 35.252L6.57738 21.496L4.54938 19.464C3.6955 18.6407 3.01423 17.6555 2.54538 16.566C2.07652 15.4765 1.82947 14.3044 1.81865 13.1183C1.80784 11.9322 2.03348 10.7559 2.4824 9.65796C2.93131 8.56005 3.5945 7.5626 4.43323 6.72387C5.27196 5.88515 6.26941 5.22196 7.36732 4.77304C8.46523 4.32412 9.64158 4.09848 10.8277 4.10929C12.0138 4.12011 13.1858 4.36716 14.2754 4.83602C15.3649 5.30488 16.3501 5.98614 17.1734 6.84002L19.2014 8.86802C19.35 9.01679 19.5264 9.1348 19.7207 9.21532C19.9149 9.29584 20.1231 9.33728 20.3334 9.33728C20.5436 9.33728 20.7519 9.29584 20.9461 9.21532C21.1403 9.1348 21.3168 9.01679 21.4654 8.86802L23.4934 6.84002C24.32 6.00789 25.3035 5.34816 26.3871 4.89909C27.4706 4.45003 28.6325 4.22057 29.8054 4.22402ZM29.8054 2.62402C27.0134 2.62469 24.3358 3.73396 22.3614 5.70802L20.3334 7.73602L18.3054 5.70802C16.324 3.76828 13.6573 2.68854 10.8845 2.70327C8.11176 2.718 5.45674 3.82602 3.49606 5.7867C1.53537 7.74738 0.427355 10.4024 0.412624 13.1752C0.397894 15.948 1.47764 18.6146 3.41738 20.596L5.44538 22.624L20.3334 37.512L35.2214 22.624L37.2494 20.596C38.7216 19.1237 39.7241 17.2478 40.1303 15.2057C40.5364 13.1636 40.328 11.0469 39.5312 9.12325C38.7344 7.19961 37.3852 5.55542 35.654 4.39858C33.9228 3.24174 31.8875 2.62419 29.8054 2.62402Z" />
    </svg>
  );
};

// Keywords: completed, tick
export const CheckIcon = (props: SVGProps<SVGSVGElement> & { alt: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      role="img"
      aria-label={props.alt}
      aria-hidden={props.alt === ""}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyStroke}`}
    >
      <title>{props.alt}</title>
      <path
        d="M5 12L9 16L19 6"
        clipRule="evenodd"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.25"
      />
    </svg>
  );
};

// Keywords: completed, tick, circle, circled
export const CheckCircledIcon = (
  props: SVGProps<SVGSVGElement> & { alt: string },
) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      role="img"
      aria-label={props.alt}
      aria-hidden={props.alt === ""}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyFill}`}
    >
      <title>{props.alt}</title>
      <path d="M17.2803 9.78033C17.5732 9.48744 17.5732 9.01256 17.2803 8.71967C16.9874 8.42678 16.5126 8.42678 16.2197 8.71967L10.25 14.6893L7.78033 12.2197C7.48744 11.9268 7.01256 11.9268 6.71967 12.2197C6.42678 12.5126 6.42678 12.9874 6.71967 13.2803L9.71967 16.2803C10.0126 16.5732 10.4874 16.5732 10.7803 16.2803L17.2803 9.78033Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1.5C5.92487 1.5 1 6.42487 1 12.5C1 18.5751 5.92487 23.5 12 23.5C18.0751 23.5 23 18.5751 23 12.5C23 6.42487 18.0751 1.5 12 1.5ZM2.5 12.5C2.5 7.25329 6.75329 3 12 3C17.2467 3 21.5 7.25329 21.5 12.5C21.5 17.7467 17.2467 22 12 22C6.75329 22 2.5 17.7467 2.5 12.5Z"
      />
    </svg>
  );
};

// Keywords: person, profile, face, head
export const AvatarIcon = (
  props: SVGProps<SVGSVGElement> & { alt: string },
) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 20 20"
      role="img"
      aria-label={props.alt}
      aria-hidden={props.alt === ""}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyFill}`}
    >
      <title>{props.alt}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 10C0 15.5228 4.47715 20 10 20C15.5203 19.9939 19.9939 15.5203 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10ZM2 10C2 5.58172 5.58172 2 10 2C14.4162 2.00496 17.995 5.58378 18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10ZM15.6655 12.2092C14.7507 11.1534 13.6185 11.6272 12.3838 12.1438C11.6193 12.4637 10.8156 12.8 9.99972 12.8C9.18459 12.8 8.38113 12.4638 7.61679 12.144C6.38176 11.6273 5.24887 11.1533 4.33392 12.2092C3.91392 12.6936 3.88032 13.3992 4.24012 13.9284C5.49592 15.7764 7.59592 17 9.99972 17C12.4035 17 14.5035 15.7764 15.7593 13.9284C16.1205 13.3992 16.0855 12.6936 15.6655 12.2092ZM14.25 7.25C14.25 9.59742 12.3474 11.5 10 11.5C7.65258 11.5 5.75 9.59742 5.75 7.25C5.75 4.90258 7.65258 3 10 3C12.3474 3 14.25 4.90258 14.25 7.25Z"
      />
      <mask
        id="mask0_328_1696"
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={20}
        height={20}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 10C0 15.5228 4.47715 20 10 20C15.5203 19.9939 19.9939 15.5203 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10ZM2 10C2 5.58172 5.58172 2 10 2C14.4162 2.00496 17.995 5.58378 18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10ZM15.6655 12.2092C14.7507 11.1534 13.6185 11.6272 12.3838 12.1438C11.6193 12.4637 10.8156 12.8 9.99972 12.8C9.18459 12.8 8.38113 12.4638 7.61679 12.144C6.38176 11.6273 5.24887 11.1533 4.33392 12.2092C3.91392 12.6936 3.88032 13.3992 4.24012 13.9284C5.49592 15.7764 7.59592 17 9.99972 17C12.4035 17 14.5035 15.7764 15.7593 13.9284C16.1205 13.3992 16.0855 12.6936 15.6655 12.2092ZM14.25 7.25C14.25 9.59742 12.3474 11.5 10 11.5C7.65258 11.5 5.75 9.59742 5.75 7.25C5.75 4.90258 7.65258 3 10 3C12.3474 3 14.25 4.90258 14.25 7.25Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_328_1696)" />
    </svg>
  );
};

// Keywords: go back, return, left arrow
export const BackArrow = (props: SVGProps<SVGSVGElement> & { alt: string }) => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      role="img"
      aria-label={props.alt}
      aria-hidden={props.alt === ""}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyFill}`}
    >
      <title>{props.alt}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.0176 7.03994H3.29277L7.89437 2.43834C8.07472 2.25842 8.17621 2.01422 8.17651 1.75947C8.17681 1.50472 8.0759 1.26029 7.89597 1.07994C7.71605 0.899593 7.47186 0.798107 7.21711 0.797806C6.96236 0.797506 6.71792 0.898417 6.53757 1.07834L0.294375 7.32154C0.249759 7.36623 0.210065 7.41558 0.175975 7.46874C0.161296 7.49113 0.148454 7.51468 0.137575 7.53914C0.118618 7.56899 0.101519 7.59999 0.0863748 7.63194C0.0863748 7.66394 0.0671748 7.69594 0.0575748 7.72794C0.0475844 7.7552 0.0390391 7.78298 0.0319748 7.81114C0.0095647 7.93601 0.0095647 8.06387 0.0319748 8.18874C0.0390391 8.2169 0.0475844 8.24468 0.0575748 8.27194C0.0575748 8.30394 0.0735748 8.33594 0.0863748 8.36794C0.101519 8.3999 0.118618 8.43089 0.137575 8.46074C0.148454 8.48521 0.161296 8.50875 0.175975 8.53114C0.210065 8.5843 0.249759 8.63365 0.294375 8.67834L6.53757 14.9215C6.71792 15.1015 6.96236 15.2024 7.21711 15.2021C7.47186 15.2018 7.71605 15.1003 7.89597 14.9199C8.0759 14.7396 8.17681 14.4952 8.17651 14.2404C8.17621 13.9857 8.07472 13.7415 7.89437 13.5615L3.29277 8.95994H15.0176C15.1436 8.95994 15.2685 8.93511 15.3849 8.88687C15.5014 8.83862 15.6073 8.76791 15.6964 8.67876C15.7855 8.58962 15.8563 8.48379 15.9045 8.36732C15.9527 8.25084 15.9776 8.12601 15.9776 7.99994C15.9776 7.87387 15.9527 7.74904 15.9045 7.63256C15.8563 7.51609 15.7855 7.41026 15.6964 7.32112C15.6073 7.23197 15.5014 7.16126 15.3849 7.11302C15.2685 7.06477 15.1436 7.03994 15.0176 7.03994V7.03994Z"
      />
    </svg>
  );
};

// Keywords: dashboard, back to home
export const DashboardIcon = (
  props: SVGProps<SVGSVGElement> & { alt: string },
) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      role="img"
      aria-label={props.alt}
      aria-hidden={props.alt === ""}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyFill} ${styles.colorifyStroke}`}
    >
      <title>{props.alt}</title>
      <g>
        <path
          d="M5 7C5 6.44772 5.44772 6 6 6H9C9.55228 6 10 6.44772 10 7V10C10 10.5523 9.55228 11 9 11H6C5.44772 11 5 10.5523 5 10V7Z"
          fill="none"
          strokeWidth="2"
        />
        <path
          d="M14 7C14 6.44772 14.4477 6 15 6H18C18.5523 6 19 6.44772 19 7V10C19 10.5523 18.5523 11 18 11H15C14.4477 11 14 10.5523 14 10V7Z"
          fill="none"
          strokeWidth="2"
        />
        <rect x="4" y="14" width="16" height="2" rx="1" strokeWidth="0" />
        <rect x="4" y="18" width="16" height="2" rx="1" strokeWidth="0" />
      </g>
    </svg>
  );
};

// Keywords: notifications, bell, bell sideways
export const NotificationIcon = (
  props: SVGProps<SVGSVGElement> & { alt: string },
) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      role="img"
      aria-label={props.alt}
      aria-hidden={props.alt === ""}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyFill}`}
    >
      <title>{props.alt}</title>
      <path
        d="M10.0002 20.0002C9.73496 20.0001 9.48065 19.8947 9.29315 19.7072C8.09819 18.6471 7.30764 17.2056 7.05615 15.6282C6.94527 14.6939 6.49596 13.8326 5.79315 13.2072C4.87353 12.1915 4.36426 10.8703 4.36426 9.50015C4.36426 8.13003 4.87353 6.80881 5.79315 5.79315C6.80881 4.87353 8.13003 4.36426 9.50015 4.36426C10.8703 4.36426 12.1915 4.87353 13.2072 5.79315C13.833 6.49595 14.6946 6.94524 15.6292 7.05615C17.2063 7.30778 18.6474 8.09832 19.7072 9.29315C19.8946 9.48068 19.9999 9.73499 19.9999 10.0002C19.9999 10.2653 19.8946 10.5196 19.7072 10.7072L10.7072 19.7072C10.5197 19.8947 10.2653 20.0001 10.0002 20.0002ZM9.50015 6.37515C8.65737 6.34791 7.83638 6.6458 7.20715 7.20715C6.64598 7.83648 6.34812 8.6574 6.37515 9.50015C6.34812 10.3429 6.64598 11.1638 7.20715 11.7932C8.19096 12.6989 8.83116 13.9172 9.01915 15.2412C9.133 16.0918 9.48563 16.8928 10.0362 17.5512L17.5522 10.0352C16.8935 9.485 16.0927 9.13243 15.2422 9.01816C13.9178 8.83097 12.6991 8.19106 11.7932 7.20715C11.1639 6.6458 10.3429 6.34791 9.50015 6.37515ZM14.7322 18.2682C14.9643 18.5003 15.24 18.6845 15.5433 18.8102C15.8467 18.9358 16.1718 19.0005 16.5002 19.0005C16.8285 19.0005 17.1536 18.9358 17.457 18.8102C17.7603 18.6845 18.036 18.5003 18.2682 18.2682C18.5003 18.036 18.6845 17.7603 18.8102 17.457C18.9358 17.1536 19.0005 16.8285 19.0005 16.5002C19.0005 16.1718 18.9358 15.8467 18.8102 15.5433C18.6845 15.24 18.5003 14.9643 18.2682 14.7322L14.7322 18.2682Z"
        strokeWidth="0"
      />
    </svg>
  );
};

// Keywords: announcements, notification, bell, bell upright
export const AnnouncementsIcon = (
  props: SVGProps<SVGSVGElement> & { alt: string },
) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 22 24"
      role="img"
      aria-label={props.alt}
      aria-hidden={props.alt === ""}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyFill} ${styles.colorifyStroke}`}
    >
      <title>{props.alt}</title>
      <path
        d="M12.73 21C12.5542 21.3031 12.3018 21.5547 11.9982 21.7295C11.6946 21.9044 11.3504 21.9965 11 21.9965C10.6496 21.9965 10.3054 21.9044 10.0018 21.7295C9.69816 21.5547 9.44581 21.3031 9.27 21M17 8C17 6.4087 16.3679 4.88258 15.2426 3.75736C14.1174 2.63214 12.5913 2 11 2C9.4087 2 7.88258 2.63214 6.75736 3.75736C5.63214 4.88258 5 6.4087 5 8C5 15 2 17 2 17H20C20 17 17 15 17 8Z"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
};

// Keywords: FAQ, question mark, circle
export const FaqIcon = (props: SVGProps<SVGSVGElement> & { alt: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      role="img"
      aria-label={props.alt}
      aria-hidden={props.alt === ""}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyFill}`}
    >
      <title>{props.alt}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM10.751 7.17226C11.1116 7.03691 11.4969 6.98025 11.8811 7.00608C12.5103 6.98446 13.1288 7.17265 13.6393 7.54105C14.1498 7.90945 14.5233 8.43714 14.7011 9.04108C14.8463 9.6161 14.7934 10.2233 14.551 10.7645C14.3086 11.3058 13.8908 11.7495 13.3651 12.0241C13.2011 12.0973 13.0589 12.2116 12.9522 12.356C12.8455 12.5003 12.7779 12.6699 12.7561 12.8481V13.2181C12.7561 13.4501 12.6639 13.6727 12.4998 13.8368C12.3357 14.0009 12.1131 14.0931 11.8811 14.0931C11.649 14.0931 11.4265 14.0009 11.2624 13.8368C11.0983 13.6727 11.0061 13.4501 11.0061 13.2181V12.8811C11.0177 12.3909 11.1607 11.9129 11.4201 11.4968C11.6796 11.0808 12.046 10.7421 12.4811 10.5161C12.6744 10.4356 12.8334 10.2898 12.9303 10.1042C13.0271 9.91848 13.0557 9.70469 13.0111 9.50008C12.9318 9.26838 12.7778 9.06959 12.5733 8.93492C12.3687 8.80026 12.1252 8.73735 11.8811 8.75608C11.3561 8.75608 10.7561 8.88108 10.7561 9.88108C10.7561 10.1131 10.6639 10.3357 10.4998 10.4998C10.3357 10.6639 10.1131 10.7561 9.88108 10.7561C9.64901 10.7561 9.42646 10.6639 9.26236 10.4998C9.09827 10.3357 9.00608 10.1131 9.00608 9.88108C8.98025 9.49686 9.03691 9.11155 9.17226 8.75103C9.30761 8.39051 9.51851 8.06311 9.79081 7.79081C10.0631 7.51851 10.3905 7.30761 10.751 7.17226ZM11.1866 14.8417C11.3922 14.7044 11.6339 14.6311 11.8811 14.6311C12.2126 14.6311 12.5305 14.7628 12.765 14.9972C12.9994 15.2316 13.1311 15.5496 13.1311 15.8811C13.1311 16.1283 13.0578 16.37 12.9204 16.5755C12.7831 16.7811 12.5878 16.9413 12.3594 17.0359C12.131 17.1305 11.8797 17.1553 11.6372 17.1071C11.3947 17.0588 11.172 16.9398 10.9972 16.765C10.8224 16.5901 10.7033 16.3674 10.6551 16.1249C10.6069 15.8825 10.6316 15.6311 10.7262 15.4027C10.8208 15.1743 10.9811 14.9791 11.1866 14.8417Z"
        strokeWidth="0"
      />
    </svg>
  );
};

// Keywords: Scan info, profile details
export const ScanInfoIcon = (
  props: SVGProps<SVGSVGElement> & { alt: string },
) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      role="img"
      aria-label={props.alt}
      aria-hidden={props.alt === ""}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyFill} ${styles.colorifyStroke}`}
    >
      <title>{props.alt}</title>
      <g>
        <path
          d="M12 11C11.7348 11 11.4804 11.1054 11.2929 11.2929C11.1054 11.4804 11 11.7348 11 12V15C11 15.2652 11.1054 15.5196 11.2929 15.7071C11.4804 15.8946 11.7348 16 12 16C12.2652 16 12.5196 15.8946 12.7071 15.7071C12.8946 15.5196 13 15.2652 13 15V12C13 11.7348 12.8946 11.4804 12.7071 11.2929C12.5196 11.1054 12.2652 11 12 11Z"
          strokeWidth="0"
        />
        <path
          d="M11.9995 10.188C12.6556 10.188 13.1875 9.65613 13.1875 9.00001C13.1875 8.3439 12.6556 7.81201 11.9995 7.81201C11.3434 7.81201 10.8115 8.3439 10.8115 9.00001C10.8115 9.65613 11.3434 10.188 11.9995 10.188Z"
          strokeWidth="0"
        />
        <path
          d="M5 9V6.5C5 5.67157 5.67157 5 6.5 5H9"
          fill="none"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 5H17.5C18.3284 5 19 5.67157 19 6.5V9"
          fill="none"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19 15V17.5C19 18.3284 18.3284 19 17.5 19H15"
          fill="none"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 15V17.5C5 18.3284 5.67157 19 6.5 19H9"
          fill="none"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

// Keywords: Settings, cog
export const SettingsIcon = (
  props: SVGProps<SVGSVGElement> & { alt: string },
) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      role="img"
      aria-label={props.alt}
      aria-hidden={props.alt === ""}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyFill}`}
    >
      <title>{props.alt}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H16.9C16.7709 13.6264 16.522 14.222 16.167 14.754L17.657 16.244C18.036 16.6364 18.0306 17.2601 17.6448 17.6458C17.2591 18.0316 16.6354 18.037 16.243 17.658L14.753 16.168C14.2212 16.5225 13.626 16.771 13 16.9V19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19V16.9C10.3698 16.7705 9.77066 16.5199 9.236 16.162C9.23047 16.1685 9.22642 16.1758 9.22239 16.183C9.21769 16.1915 9.21301 16.2 9.206 16.207L7.756 17.657C7.50493 17.917 7.13312 18.0212 6.78349 17.9297C6.43386 17.8382 6.16082 17.5651 6.0693 17.2155C5.97779 16.8659 6.08204 16.4941 6.342 16.243L7.792 14.793C7.79865 14.7863 7.80662 14.7821 7.81468 14.7777C7.82238 14.7735 7.83017 14.7693 7.837 14.763C7.47957 14.2286 7.22927 13.6298 7.1 13H5C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11H7.1C7.22925 10.3739 7.47814 9.77872 7.833 9.247L6.343 7.757C5.95226 7.36653 5.95203 6.73324 6.3425 6.3425C6.73297 5.95176 7.36626 5.95153 7.757 6.342L9.247 7.832C9.77881 7.47751 10.374 7.22897 11 7.1V5C11 4.44772 11.4477 4 12 4C12.5523 4 13 4.44772 13 5V7.1C13.6264 7.22915 14.222 7.47804 14.754 7.833L16.244 6.343C16.6364 5.96403 17.2601 5.96945 17.6458 6.35518C18.0316 6.74092 18.037 7.36462 17.658 7.757L16.168 9.247C16.5225 9.7788 16.7711 10.374 16.9 11ZM12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9Z"
        strokeWidth="0"
      />
    </svg>
  );
};

// Keywords: tip, light bulb, idea, how it works
export const TipIcon = (props: SVGProps<SVGSVGElement> & { alt: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      role="img"
      aria-label={props.alt}
      aria-hidden={props.alt === ""}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyFill}`}
    >
      <title>{props.alt}</title>
      <path
        d="M14 17H10C9.73478 17 9.48043 16.8946 9.29289 16.7071C9.10536 16.5196 9 16.2652 9 16C8.78941 15.2971 8.41202 14.6556 7.9 14.13C6.82591 13.0023 6.15748 11.5494 6 10C6 9.21207 6.15519 8.43185 6.45672 7.7039C6.75825 6.97595 7.20021 6.31451 7.75736 5.75736C8.31451 5.20021 8.97595 4.75825 9.7039 4.45672C10.4319 4.15519 11.2121 4 12 4C12.7879 4 13.5681 4.15519 14.2961 4.45672C15.0241 4.75825 15.6855 5.20021 16.2426 5.75736C16.7998 6.31451 17.2417 6.97595 17.5433 7.7039C17.8448 8.43185 18 9.21207 18 10C17.8425 11.5494 17.1741 13.0023 16.1 14.13C15.588 14.6556 15.2106 15.2971 15 16C15 16.2652 14.8946 16.5196 14.7071 16.7071C14.5196 16.8946 14.2652 17 14 17ZM10.812 15H13.188C13.5259 14.2411 13.9733 13.5359 14.516 12.907C15.2979 12.1137 15.8161 11.0986 16 10C15.986 8.94348 15.5601 7.93417 14.813 7.18703C14.0658 6.4399 13.0565 6.01398 12 6C10.9435 6.01398 9.93417 6.4399 9.18703 7.18703C8.4399 7.93417 8.01398 8.94348 8 10C8.18391 11.0986 8.70213 12.1137 9.484 12.907C10.027 13.536 10.474 14.241 10.812 15ZM14 20H10C9.73478 20 9.48043 19.8946 9.29289 19.7071C9.10536 19.5196 9 19.2652 9 19C9 18.7348 9.10536 18.4804 9.29289 18.2929C9.48043 18.1054 9.73478 18 10 18H14C14.2652 18 14.5196 18.1054 14.7071 18.2929C14.8946 18.4804 15 18.7348 15 19C15 19.2652 14.8946 19.5196 14.7071 19.7071C14.5196 19.8946 14.2652 20 14 20Z"
        strokeWidth="0"
      />
    </svg>
  );
};

// Keywords: link, URL, href
export const LinkIcon = (props: SVGProps<SVGSVGElement> & { alt: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      role="img"
      aria-label={props.alt}
      aria-hidden={props.alt === ""}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyFill}`}
    >
      <title>{props.alt}</title>
      <path d="M10.0471 8.6328C9.65658 8.24227 9.02341 8.24227 8.63289 8.6328C8.24236 9.02332 8.24236 9.65649 8.63289 10.047L13.886 15.3001C14.2765 15.6906 14.9097 15.6906 15.3002 15.3001C15.6907 14.9096 15.6907 14.2764 15.3002 13.8859L10.0471 8.6328Z" />
      <path d="M6.32008 8.48808L8.45108 6.35608C8.49758 6.30907 8.55294 6.27174 8.61397 6.24627C8.67499 6.2208 8.74046 6.20768 8.80658 6.20768C8.87271 6.20768 8.93818 6.2208 8.9992 6.24627C9.06022 6.27174 9.11558 6.30907 9.16208 6.35608L12.3521 9.54608L12.3661 9.53108C12.7389 9.15632 12.9482 8.6492 12.9482 8.12058C12.9482 7.59197 12.7389 7.08485 12.3661 6.71008L10.2381 4.58208C9.86332 4.20928 9.3562 4 8.82758 4C8.29897 4 7.79185 4.20928 7.41708 4.58208L4.58208 7.41708C4.20928 7.79185 4 8.29897 4 8.82758C4 9.3562 4.20928 9.86332 4.58208 10.2381L6.71008 12.3661C7.08043 12.7369 7.58192 12.9469 8.10598 12.9506C8.63004 12.9544 9.13448 12.7516 9.51008 12.3861L6.32008 9.20008C6.27292 9.15357 6.23546 9.09814 6.2099 9.03703C6.18434 8.97591 6.17117 8.91033 6.17117 8.84408C6.17117 8.77784 6.18434 8.71225 6.2099 8.65114C6.23546 8.59002 6.27292 8.5346 6.32008 8.48808ZM19.3821 13.7251L17.2531 11.5961C16.8783 11.2233 16.3712 11.014 15.8426 11.014C15.314 11.014 14.8068 11.2233 14.4321 11.5961L14.4171 11.6111L17.6061 14.8001C17.6531 14.8466 17.6904 14.9019 17.7159 14.963C17.7414 15.024 17.7545 15.0895 17.7545 15.1556C17.7545 15.2217 17.7414 15.2872 17.7159 15.3482C17.6904 15.4092 17.6531 15.4646 17.6061 15.5111L15.4741 17.6431C15.4276 17.6901 15.3722 17.7274 15.3112 17.7529C15.2502 17.7784 15.1847 17.7915 15.1186 17.7915C15.0525 17.7915 14.987 17.7784 14.926 17.7529C14.8649 17.7274 14.8096 17.6901 14.7631 17.6431L11.5761 14.4561C11.2106 14.8317 11.0078 15.3361 11.0115 15.8602C11.0153 16.3842 11.2253 16.8857 11.5961 17.2561L13.7241 19.3841C14.0988 19.7569 14.606 19.9662 15.1346 19.9662C15.6632 19.9662 16.1703 19.7569 16.5451 19.3841L19.3801 16.5491C19.7541 16.1745 19.9643 15.6668 19.9647 15.1375C19.965 14.6081 19.7555 14.1002 19.3821 13.7251Z" />
    </svg>
  );
};

// Keywords: plus, add
export const PlusIcon = (props: SVGProps<SVGSVGElement> & { alt: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      role="img"
      aria-label={props.alt}
      aria-hidden={props.alt === ""}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyStroke}`}
    >
      <title>{props.alt}</title>
      <path
        d="M12 6V12M12 18V12M12 12H18M12 12H6"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

// Keywords: plus, circle, circled, add
export const PlusCircledIcon = (
  props: SVGProps<SVGSVGElement> & { alt: string },
) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      role="img"
      aria-label={props.alt}
      aria-hidden={props.alt === ""}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyFill}`}
    >
      <title>{props.alt}</title>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 7.5C12.5523 7.5 13 7.94772 13 8.5V11H15.5C16.0523 11 16.5 11.4477 16.5 12C16.5 12.5523 16.0523 13 15.5 13H13V15.5C13 16.0523 12.5523 16.5 12 16.5C11.4477 16.5 11 16.0523 11 15.5V13H8.5C7.94772 13 7.5 12.5523 7.5 12C7.5 11.4477 7.94772 11 8.5 11H11V8.5C11 7.94772 11.4477 7.5 12 7.5Z"
        />
      </g>
    </svg>
  );
};

// Keywords: minus, circle, circled, remove
export const MinusCircledIcon = (
  props: SVGProps<SVGSVGElement> & { alt: string },
) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      role="img"
      aria-label={props.alt}
      aria-hidden={props.alt === ""}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyFill}`}
    >
      <title>{props.alt}</title>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.5 12C7.5 11.4477 7.94772 11 8.5 11H15.5C16.0523 11 16.5 11.4477 16.5 12C16.5 12.5523 16.0523 13 15.5 13H8.5C7.94772 13 7.5 12.5523 7.5 12Z"
        />
      </g>
    </svg>
  );
};

// Keywords: search, magnifying glass, find
export const SearchIcon = (
  props: SVGProps<SVGSVGElement> & { alt: string },
) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      role="img"
      aria-label={props.alt}
      aria-hidden={props.alt === ""}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyFill}`}
    >
      <title>{props.alt}</title>
      <path d="m19.745 18.33-4.822-4.821a6.018 6.018 0 1 0-1.414 1.414l4.822 4.822a1 1 0 0 0 1.414-1.414m-9.707-4.292a4 4 0 1 1 0-7.999 4 4 0 0 1 0 7.999"></path>
    </svg>
  );
};

// Keywords: VPN
export const VpnIcon = (props: SVGProps<SVGSVGElement> & { alt: string }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      role="img"
      fill="none"
      aria-label={props.alt}
      aria-hidden={props.alt === ""}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyFill}`}
    >
      <title>{props.alt}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 2.05128C9.15033 2.05128 8.46154 2.74008 8.46154 3.58974C8.46154 4.43941 9.15033 5.1282 10 5.1282C10.8497 5.1282 11.5385 4.43941 11.5385 3.58974C11.5385 2.74008 10.8497 2.05128 10 2.05128ZM6.41026 3.58974C6.41026 1.60718 8.01744 0 10 0C11.9826 0 13.5897 1.60718 13.5897 3.58974C13.5897 5.57231 11.9826 7.17949 10 7.17949C9.38179 7.17949 8.80008 7.0232 8.2922 6.748L6.748 8.2922C6.86456 8.50728 6.95977 8.73562 7.03082 8.97436H12.9692C13.4105 7.49154 14.7841 6.41026 16.4103 6.41026C18.3928 6.41026 20 8.01744 20 10C20 11.9826 18.3928 13.5897 16.4103 13.5897C15.7921 13.5897 15.2103 13.4335 14.7025 13.1583L13.1583 14.7025C13.4335 15.2103 13.5897 15.7921 13.5897 16.4103C13.5897 18.3928 11.9826 20 10 20C8.01744 20 6.41026 18.3928 6.41026 16.4103C6.41026 14.4277 8.01744 12.8205 10 12.8205C10.6182 12.8205 11.1999 12.9768 11.7078 13.252L13.252 11.7078C13.1354 11.4927 13.0402 11.2644 12.9692 11.0256H7.03082C6.58954 12.5085 5.2159 13.5897 3.58974 13.5897C1.60718 13.5897 0 11.9826 0 10C0 8.01744 1.60718 6.41026 3.58974 6.41026C4.20795 6.41026 4.78967 6.56654 5.29754 6.84172L6.84172 5.29754C6.56654 4.78967 6.41026 4.20795 6.41026 3.58974ZM8.46154 16.4103C8.46154 15.5606 9.15033 14.8718 10 14.8718C10.8497 14.8718 11.5385 15.5606 11.5385 16.4103C11.5385 17.2599 10.8497 17.9487 10 17.9487C9.15033 17.9487 8.46154 17.2599 8.46154 16.4103ZM3.58974 8.46154C2.74008 8.46154 2.05128 9.15033 2.05128 10C2.05128 10.8497 2.74008 11.5385 3.58974 11.5385C4.43941 11.5385 5.1282 10.8497 5.1282 10C5.1282 9.15033 4.43941 8.46154 3.58974 8.46154ZM14.8718 10C14.8718 9.15033 15.5606 8.46154 16.4103 8.46154C17.2599 8.46154 17.9487 9.15033 17.9487 10C17.9487 10.8497 17.2599 11.5385 16.4103 11.5385C15.5606 11.5385 14.8718 10.8497 14.8718 10Z"
      />
    </svg>
  );
};

// Keywords: Relay
export const RelayIcon = (props: SVGProps<SVGSVGElement> & { alt: string }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      role="img"
      fill="none"
      aria-label={props.alt}
      aria-hidden={props.alt === ""}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyFill}`}
    >
      <title>{props.alt}</title>
      <path d="M10.1138 0.00152588C10.596 0.0167077 11.0686 0.137965 11.4984 0.355835L11.59 0.403748L11.6028 0.410767L11.6156 0.418091L17.5574 3.78937C18.0337 4.05244 18.4341 4.43146 18.7228 4.89014L18.7808 4.98566L18.8354 5.08331C19.0925 5.56229 19.2237 6.09863 19.2181 6.64215L19.2184 13.3685C19.2168 13.9463 19.063 14.5143 18.772 15.0143C18.4809 15.5144 18.0623 15.9294 17.5577 16.2158L17.5552 16.2173L17.5528 16.2186L11.611 19.5685C11.1261 19.8472 10.5771 19.9962 10.0168 19.9997L10.0171 20C10.0142 20 10.0112 19.9997 10.0082 19.9997C10.007 19.9997 10.0058 20 10.0046 20L10.0043 19.9997C9.43401 20.0026 8.87454 19.8522 8.38318 19.5654L2.4469 16.2186L2.4472 16.2183C1.93869 15.9338 1.51675 15.5185 1.22437 15.0162C0.932082 14.514 0.779658 13.9434 0.781555 13.3633L0.78125 6.63666C0.782916 6.0589 0.936671 5.49116 1.22772 4.99115L1.28387 4.89838C1.57158 4.43964 1.96891 4.05791 2.44202 3.78937L2.44476 3.78784L8.40759 0.41687L8.41888 0.410156L8.43048 0.403748C8.9146 0.138979 9.4579 0 10.0104 0L10.1138 0.00152588ZM2.65625 13.3633C2.65434 13.6126 2.71939 13.8578 2.84454 14.0729C2.96977 14.288 3.15061 14.4651 3.36761 14.5853L9.30939 17.9352C9.51768 18.0614 9.75662 18.1272 9.99969 18.125C10.2424 18.1244 10.4809 18.0588 10.6903 17.9352L16.6321 14.5853C16.8204 14.4784 16.9811 14.3292 17.102 14.1498L17.1515 14.071C17.2764 13.8564 17.3427 13.6121 17.3434 13.3633V6.64215C17.3496 6.39196 17.286 6.14485 17.1603 5.92895C17.0347 5.71312 16.8518 5.53671 16.6321 5.41992L10.6903 2.04895C10.4816 1.93482 10.2478 1.87502 10.0104 1.875C9.7729 1.875 9.53913 1.93483 9.33044 2.04895L3.36761 5.41992L3.28857 5.46844C3.10838 5.5872 2.95753 5.74663 2.84821 5.93445C2.72326 6.14911 2.65696 6.39333 2.65625 6.64215V13.3633Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.00546 7.01255C5.14683 6.77033 5.4578 6.68858 5.70002 6.82996L6.12293 7.07679C6.36514 7.21817 6.4469 7.52913 6.30552 7.77135C6.16415 8.01357 5.85319 8.09532 5.61097 7.95394L5.18806 7.70711C4.94584 7.56573 4.86409 7.25477 5.00546 7.01255ZM6.95085 8.148C7.09223 7.90578 7.40319 7.82403 7.64541 7.96541L8.49123 8.45908C8.73345 8.60046 8.8152 8.91142 8.67383 9.15364C8.53245 9.39585 8.22149 9.47761 7.97927 9.33623L7.13345 8.84256C6.89123 8.70118 6.80948 8.39022 6.95085 8.148ZM9.31916 9.53029C9.46053 9.28807 9.77149 9.20632 10.0137 9.3477L10.0842 9.38884C10.2901 9.34904 10.5075 9.44024 10.6192 9.63158C10.6795 9.73483 10.6992 9.85056 10.6832 9.96033C10.6992 10.0701 10.6795 10.1858 10.6192 10.2891C10.5075 10.4804 10.2901 10.5716 10.0842 10.5318L10.0137 10.573C9.77149 10.7143 9.46053 10.6326 9.31916 10.3904C9.23993 10.2546 9.23078 10.0973 9.28067 9.96033C9.23078 9.82336 9.23993 9.66603 9.31916 9.53029ZM8.67383 10.767C8.8152 11.0092 8.73345 11.3202 8.49123 11.4616L7.64541 11.9553C7.40319 12.0966 7.09223 12.0149 6.95085 11.7727C6.80948 11.5304 6.89123 11.2195 7.13345 11.0781L7.97927 10.5844C8.22149 10.4431 8.53245 10.5248 8.67383 10.767ZM6.30552 12.1493C6.4469 12.3915 6.36514 12.7025 6.12293 12.8439L5.70002 13.0907C5.4578 13.2321 5.14683 13.1503 5.00546 12.9081C4.86409 12.6659 4.94584 12.3549 5.18806 12.2136L5.61097 11.9667C5.85319 11.8254 6.16415 11.9071 6.30552 12.1493Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.1251 7.01255C15.2664 7.25477 15.1847 7.56573 14.9425 7.70711L14.5196 7.95394C14.2773 8.09532 13.9664 8.01357 13.825 7.77135C13.6836 7.52913 13.7654 7.21817 14.0076 7.07679L14.4305 6.82996C14.6727 6.68858 14.9837 6.77033 15.1251 7.01255ZM13.1797 8.148C13.321 8.39022 13.2393 8.70118 12.9971 8.84256L12.1513 9.33623C11.909 9.47761 11.5981 9.39585 11.4567 9.15364C11.3153 8.91142 11.3971 8.60046 11.6393 8.45908L12.4851 7.96541C12.7273 7.82403 13.0383 7.90578 13.1797 8.148ZM9.44729 9.96033C9.43132 10.0701 9.45104 10.1858 9.5113 10.2891C9.62298 10.4804 9.84047 10.5716 10.0463 10.5318L10.1168 10.573C10.359 10.7143 10.67 10.6326 10.8114 10.3904C10.8906 10.2546 10.8997 10.0973 10.8499 9.96033C10.8997 9.82336 10.8906 9.66603 10.8114 9.53029C10.67 9.28807 10.359 9.20632 10.1168 9.3477L10.0463 9.38884C9.84047 9.34904 9.62298 9.44024 9.5113 9.63158C9.45104 9.73483 9.43132 9.85056 9.44729 9.96033ZM11.4567 10.767C11.5981 10.5248 11.909 10.4431 12.1513 10.5844L12.9971 11.0781C13.2393 11.2195 13.321 11.5304 13.1797 11.7727C13.0383 12.0149 12.7273 12.0966 12.4851 11.9553L11.6393 11.4616C11.3971 11.3202 11.3153 11.0092 11.4567 10.767ZM13.825 12.1493C13.9664 11.9071 14.2773 11.8254 14.5196 11.9667L14.9425 12.2136C15.1847 12.3549 15.2664 12.6659 15.1251 12.9081C14.9837 13.1503 14.6727 13.2321 14.4305 13.0907L14.0076 12.8439C13.7654 12.7025 13.6836 12.3915 13.825 12.1493Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0648 4.22157C10.3453 4.22157 10.5727 4.44893 10.5727 4.72938L10.5727 15.2919C10.5727 15.5723 10.3453 15.7997 10.0648 15.7997C9.78439 15.7997 9.55703 15.5723 9.55703 15.2919V4.72938C9.55703 4.44893 9.78439 4.22157 10.0648 4.22157Z"
      />
    </svg>
  );
};

// Keywords: Monitor
export const MonitorIcon = (
  props: SVGProps<SVGSVGElement> & { alt: string },
) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      role="img"
      fill="none"
      aria-label={props.alt}
      aria-hidden={props.alt === ""}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`${props.className ?? ""} ${styles.colorifyFill}`}
    >
      <title>{props.alt}</title>
      <path d="M17.9597 4.18429L15.9486 3.03231L11.3571 0.403416L11.2143 0.321285C10.4615 -0.107095 9.53877 -0.107095 8.78604 0.321285L8.64321 0.40413L2.18702 4.10215L2.04418 4.185C1.29537 4.61375 0.832464 5.40968 0.830078 6.27255V13.9964C0.832651 14.8594 1.29548 15.6555 2.04418 16.0847L8.64535 19.8648C9.12911 20.1426 9.7463 19.9788 10.0287 19.4977C10.1631 19.2669 10.1995 18.9919 10.1299 18.734C10.0603 18.4762 9.89036 18.2569 9.65806 18.1251L3.20187 14.4278C2.98734 14.3054 2.85465 14.0777 2.85406 13.8307V6.43824C2.85465 6.19128 2.98734 5.96351 3.20187 5.84118L9.65091 2.14102C9.86568 2.01887 10.1289 2.01887 10.3437 2.14102L16.802 5.83976C17.0155 5.96254 17.1475 6.18977 17.1484 6.4361V13.8336C17.1478 14.0805 17.0151 14.3083 16.8006 14.4306L14.6159 15.6819L13.5132 14.0193C14.625 13.0345 15.2617 11.6207 15.2622 10.1355C15.2622 7.25526 12.9004 4.91203 9.99658 4.91203C7.09272 4.91203 4.73093 7.25526 4.73093 10.1355C4.73093 13.0158 7.09272 15.3591 9.99658 15.3591C10.6024 15.3596 11.2037 15.2557 11.7742 15.052L13.4489 17.5773C13.4751 17.6158 13.5034 17.6528 13.5339 17.688L13.5518 17.7059C13.5871 17.744 13.6256 17.7791 13.6667 17.8108C13.6767 17.8187 13.686 17.8273 13.6967 17.8351C13.7421 17.8678 13.7898 17.8969 13.8396 17.9223L13.8739 17.9373C13.9184 17.9572 13.9642 17.9741 14.011 17.988L14.0424 17.998C14.0956 18.0114 14.1498 18.0203 14.2045 18.0244H14.2495C14.2652 18.0244 14.2802 18.0244 14.2959 18.0244C14.3267 18.0244 14.3574 18.0208 14.3874 18.018C14.4016 18.018 14.4152 18.018 14.4295 18.018C14.4872 18.01 14.544 17.9971 14.5995 17.9794C14.6145 17.9751 14.6288 17.9687 14.6437 17.963C14.6879 17.9469 14.7308 17.9278 14.7723 17.9058C14.7816 17.9008 14.7923 17.898 14.8016 17.8923L17.9597 16.0875C18.7092 15.6577 19.1721 14.8604 19.1738 13.9964V6.27183C19.1714 5.40897 18.7085 4.61303 17.9597 4.18429ZM6.75563 10.1355C6.74463 8.82229 7.52725 7.63222 8.7374 7.12202C9.94755 6.61182 11.346 6.88237 12.2785 7.8071C13.211 8.73183 13.4933 10.1279 12.9933 11.3423C12.4933 12.5567 11.3099 13.3494 9.99658 13.3494C8.21511 13.3545 6.76546 11.917 6.75563 10.1355Z" />
      <path d="M17.9597 4.18429L15.9486 3.03231L11.3571 0.403416L11.2143 0.321285C10.4615 -0.107095 9.53877 -0.107095 8.78604 0.321285L8.64321 0.40413L2.18702 4.10215L2.04418 4.185C1.29537 4.61375 0.832464 5.40968 0.830078 6.27255V13.9964C0.832651 14.8594 1.29548 15.6555 2.04418 16.0847L8.64535 19.8648C9.12911 20.1426 9.7463 19.9788 10.0287 19.4977C10.1631 19.2669 10.1995 18.9919 10.1299 18.734C10.0603 18.4762 9.89036 18.2569 9.65806 18.1251L3.20187 14.4278C2.98734 14.3054 2.85465 14.0777 2.85406 13.8307V6.43824C2.85465 6.19128 2.98734 5.96351 3.20187 5.84118L9.65091 2.14102C9.86568 2.01887 10.1289 2.01887 10.3437 2.14102L16.802 5.83976C17.0155 5.96254 17.1475 6.18977 17.1484 6.4361V13.8336C17.1478 14.0805 17.0151 14.3083 16.8006 14.4306L14.6159 15.6819L13.5132 14.0193C14.625 13.0345 15.2617 11.6207 15.2622 10.1355C15.2622 7.25526 12.9004 4.91203 9.99658 4.91203C7.09272 4.91203 4.73093 7.25526 4.73093 10.1355C4.73093 13.0158 7.09272 15.3591 9.99658 15.3591C10.6024 15.3596 11.2037 15.2557 11.7742 15.052L13.4489 17.5773C13.4751 17.6158 13.5034 17.6528 13.5339 17.688L13.5518 17.7059C13.5871 17.744 13.6256 17.7791 13.6667 17.8108C13.6767 17.8187 13.686 17.8273 13.6967 17.8351C13.7421 17.8678 13.7898 17.8969 13.8396 17.9223L13.8739 17.9373C13.9184 17.9572 13.9642 17.9741 14.011 17.988L14.0424 17.998C14.0956 18.0114 14.1498 18.0203 14.2045 18.0244H14.2495C14.2652 18.0244 14.2802 18.0244 14.2959 18.0244C14.3267 18.0244 14.3574 18.0208 14.3874 18.018C14.4016 18.018 14.4152 18.018 14.4295 18.018C14.4872 18.01 14.544 17.9971 14.5995 17.9794C14.6145 17.9751 14.6288 17.9687 14.6437 17.963C14.6879 17.9469 14.7308 17.9278 14.7723 17.9058C14.7816 17.9008 14.7923 17.898 14.8016 17.8923L17.9597 16.0875C18.7092 15.6577 19.1721 14.8604 19.1738 13.9964V6.27183C19.1714 5.40897 18.7085 4.61303 17.9597 4.18429ZM6.75563 10.1355C6.74463 8.82229 7.52725 7.63222 8.7374 7.12202C9.94755 6.61182 11.346 6.88237 12.2785 7.8071C13.211 8.73183 13.4933 10.1279 12.9933 11.3423C12.4933 12.5567 11.3099 13.3494 9.99658 13.3494C8.21511 13.3545 6.76546 11.917 6.75563 10.1355Z" />
      <path d="M17.9597 4.18429L15.9486 3.03231L13.1432 1.42681C12.4985 1.0585 11.7098 1.04664 11.0543 1.39539L9.65091 2.14102C9.86568 2.01887 10.1289 2.01887 10.3437 2.14102L16.802 5.83976C17.0155 5.96254 17.1475 6.18977 17.1484 6.4361V13.8336C17.1478 14.0805 17.0151 14.3083 16.8006 14.4306L14.6159 15.6819L14.9566 16.2268C15.3644 16.8769 16.2131 17.0885 16.8784 16.706L17.9597 16.0875C18.7104 15.6589 19.1738 14.8608 19.1738 13.9964V6.27183C19.1727 5.40861 18.7095 4.61206 17.9597 4.18429Z" />
      <path d="M17.1484 6.43822V10.027H19.1738L19.1738 6.27183C19.1727 5.40861 18.7095 4.61206 17.9597 4.18429L15.9486 3.03231L13.1432 1.42681C12.4985 1.0585 11.7098 1.04664 11.0543 1.39539L9.65091 2.14102C9.86568 2.01887 10.1289 2.01887 10.3437 2.14102L16.802 5.83976C17.0162 5.96292 17.1483 6.19112 17.1484 6.43822Z" />
      <path d="M17.1484 10.6048L17.1484 13.8336C17.1478 14.0805 17.0151 14.3083 16.8006 14.4306L14.6159 15.6819L14.9566 16.2268C15.3644 16.8769 16.2131 17.0885 16.8784 16.706L17.9597 16.0875C18.7104 15.6589 19.1738 14.8608 19.1738 13.9964L19.1738 10.6048H17.1484Z" />
      <path d="M14.4602 15.4476L13.5132 14.0193C13.0056 14.4725 12.4151 14.8232 11.7742 15.052L12.7812 16.5725C13.3501 16.2096 13.9098 15.8347 14.4602 15.4476Z" />
    </svg>
  );
};
